import gql from 'graphql-tag'
import { EntityFields, EnumFields } from '..'

export const PlatformFragment = gql`
  fragment Platform on platform{
    ${EntityFields}
    ${EnumFields}
  }
`
